export const VIEWPORT_REQUEST_ORIGIN = Object.freeze({
  LOCAL: 'local',
  LOCAL_NAVIGATION: 'local-navigation',
  LOCAL_LINKED: 'local-linked',
  LINKED_FOLLOWER: 'linked-follower',
  LINKED_FOLLOWER_RETRY: 'linked-follower-retry',
  TRIANGULATION: 'triangulation',
  KEYBOARD: 'keyboard',
  MULTI_MONITOR_INBOUND: 'multi-monitor-inbound',
});

export const shouldPublishAcceptedViewportScroll = meta => (
  meta?.requestOrigin === VIEWPORT_REQUEST_ORIGIN.LOCAL_NAVIGATION
  || meta?.requestOrigin === VIEWPORT_REQUEST_ORIGIN.LOCAL_LINKED
  || meta?.requestOrigin === VIEWPORT_REQUEST_ORIGIN.KEYBOARD
);

export const isLocalLinkedRequest = requestOrigin => (
  requestOrigin === VIEWPORT_REQUEST_ORIGIN.LOCAL_LINKED
);

export const shouldPublishAcceptedLinkedAuthority = requestOrigin => (
  requestOrigin === VIEWPORT_REQUEST_ORIGIN.LOCAL_LINKED
  || requestOrigin === VIEWPORT_REQUEST_ORIGIN.MULTI_MONITOR_INBOUND
);
